/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Fragment, useEffect, useState } from 'react';
import image from '../../assets/images/model/image-icon.svg';
import plusCricle from '../../assets/images/model/plus-addmedia.svg';
import maximizeImage from '../../assets/images/model/maximize.png';
import ImageUploader from '../../Pages/Book/addMedia/ImageUploader';
import video from '../../assets/images/model/video_icon.svg';
import audio from '../../assets/images/model/audio-icon.svg';
import VideoUploadComponent from '../../Pages/Book/addMedia/VideoUploadComponent';
import AudioUploadComponent from '../../Pages/Book/addMedia/AudioUploadComponent';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import { createPortal } from 'react-dom';
import { ModalPortal } from '../ModalPortal';

export default function MediaComponent({
  media,
  onSuccess,
  isEditing,
  mode,
  setMaximizeImage,
  setImageVideoUrl,
}) {
  const [mediaObj, setMediaObj] = useState(media);

  useEffect(() => {
    setMediaObj(media);
  }, [media]);
  const [uploadModal, setUploadModal] = useState('');
  const maximizeToggle = (prev) => {
    setMaximizeImage(!prev);
  };

  const mediaUrl =
    mediaObj?.url || mediaObj?.activityInstructionUrl || mediaObj?.questionMediaTypeUrl || '';

  const type =
    mediaObj?.type ||
    mediaObj?.activityInstructionsType ||
    mediaObj?.questionInstructionsType ||
    (mediaUrl.includes('.mp3') ? 'audio' : mediaUrl.includes('.mp4') ? 'video' : 'image');

  return (
    <>
      <div className={`image-default-heigh ${mode && 'img-student'}`}>
        {mediaUrl ? (
          <div
            style={{
              width: '100%',
              justifyContent: `${type !== 'video' ? 'center' : ''}`,
              position: 'relative',
            }}
          >
            {type === 'image' ||
            ['image', 'text'].includes(mediaObj.activityInstructionsType) ||
            ['image', 'text'].includes(mediaObj?.type) ? (
              <>
                <img
                  style={{
                    borderRadius: '2px',
                    height: isEditing
                      ? '120px'
                      : mode
                      ? '164px'
                      : mediaObj.activityInstructionUrl
                      ? '150px'
                      : '77px',
                    width: '100%',
                    paddingBottom: mode ? '8px' : '0px',
                    objectFit: 'cover',
                  }}
                  src={mediaUrl}
                  alt={mediaObj.alt}
                />
                <img
                  className='maximize-image'
                  src={maximizeImage}
                  alt='maximize'
                  onClick={(e) => {
                    e.stopPropagation();
                    maximizeToggle();
                    setImageVideoUrl(mediaObj);
                  }}
                />
              </>
            ) : type === 'audio' || ['audio'].includes(mediaObj.activityInstructionsType) ? (
              <AudioPlayer
                style={{ width: '100%', background: 'var(--White, #fff)' }}
                autoPlay={false}
                src={mediaUrl}
              />
            ) : type === 'video' || ['video'].includes(mediaObj.activityInstructionsType) ? (
              <>
                <iframe
                  width='100%'
                  style={{
                    height: isEditing
                      ? '120px'
                      : mode
                      ? '164px'
                      : mediaObj.activityInstructionUrl
                      ? '150px'
                      : '77px',
                  }}
                  src={mediaUrl}
                ></iframe>
                <img
                  className='maximize-image'
                  src={maximizeImage}
                  alt='maximize'
                  onClick={(e) => {
                    e.stopPropagation();
                    maximizeToggle();
                    setImageVideoUrl(mediaObj);
                  }}
                />
              </>
            ) : (
              ''
            )}
          </div>
        ) : (
          <Fragment>
            <UploadImageDrage
              item={mediaObj}
              setUploadModal={setUploadModal}
              isEditing={isEditing}
            />
          </Fragment>
        )}
        {uploadModal === 'image' && (
          <ModalPortal>
            <ImageUploader
              setUploadImageShow={() => {
                setUploadModal('');
              }}
              onSuccess={onSuccess}
            />
          </ModalPortal>
        )}
        {uploadModal === 'audio' && (
          <ModalPortal>
            <AudioUploadComponent
              setUploadAudioShow={() => {
                setUploadModal('');
              }}
              onSuccess={onSuccess}
            />
          </ModalPortal>
        )}
        {uploadModal === 'video' && (
          <ModalPortal>
            <VideoUploadComponent
              setUploadVideo={() => {
                setUploadModal('');
              }}
              setUploadVideoShow={() => {
                setUploadModal('');
              }}
              onSuccess={onSuccess}
            />
          </ModalPortal>
        )}
      </div>
    </>
  );
}
function UploadImageDrage({ item, setUploadModal, isEditing }) {
  const mediaUrl = item.url || item.activityInstructionUrl;

  let type = item.type;
  if (!type && mediaUrl) {
    if (mediaUrl.includes('.mp3')) {
      type = 'audio';
    } else if (mediaUrl.includes('.mp4')) {
      type = 'video';
    } else {
      type = 'image';
    }
  }

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {isEditing && (
        <div
          className='chapter_img_box'
          style={{
            width: '100%',
            height: `${type === 'audio' ? '67px' : isEditing ? '100px' : '77px'}`,
          }}
          onClick={() => {
            if (isEditing) {
              setUploadModal(type || 'image'); // fallback to image type for new upload
            }
          }}
        >
          <div
            style={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <img
              src={type === 'video' ? video : type === 'audio' ? audio : image}
              style={{ display: 'block' }}
              alt='add'
            />
            <img
              src={plusCricle}
              alt='plusCircle'
              style={{
                position: 'absolute',
                top: 0,
                left: 12,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
